export default "__VITE_ASSET__ff7610ee__"